import { Fragment } from 'react'
import Card from './Card'
import style from '../../styles/components/story-collection/story-collection'

const MobileSection = ({ stories, type }) =>
  stories
    ?.filter((story) => story)
    ?.map((story) => (
      <Fragment key={story.slug}>
        <div className='mobile two-column mobile-fill'>
          <Card story={story} cardType={type} />
        </div>
        <style jsx>{style}</style>
      </Fragment>
    ))

export default MobileSection
